import { IBalanceOfTrade } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getDataOrNil } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getDataOrNil'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import {
  createBoTItem,
  getFieldsByActualsValueTypes,
} from '../../../helpers/balanceOfTradeFieldsHelper'
import { getFormedEltTranslationForKeys } from '../../../helpers/getFormedEltTranslationForKeys'

const getNumberValue = (item: IBalanceOfTrade | undefined, field: string | undefined): number => {
  if (!field) {
    return 0
  }

  return getDataOrNil(item?.[field as keyof IBalanceOfTrade] as number | undefined)
}

export const getBoTInitialData = (
  balanceOfTradeData: IBalanceOfTrade[] | undefined,
  actualValueTypes: ActualsValueTypes[] = []
): IBalanceOfTrade[] => {
  const hpSpendData = balanceOfTradeData?.find((el) => el.Key === 'HPSpend')
  const totalRevenueData = balanceOfTradeData?.find((el) => el.Key === 'TotalRevenue')

  const totalRevenueFields = getFieldsByActualsValueTypes(actualValueTypes, ({ botField }) =>
    getNumberValue(totalRevenueData, botField)
  )

  const hpSpendFields = getFieldsByActualsValueTypes(actualValueTypes, ({ botField }) =>
    getNumberValue(hpSpendData, botField)
  )

  const balanceOfTradeFields = getFieldsByActualsValueTypes(
    actualValueTypes,
    ({ botField }) =>
      getNumberValue(totalRevenueData, botField) - getNumberValue(hpSpendData, botField)
  )

  return [
    createBoTItem(
      'TotalRevenue',
      getFormedEltTranslationForKeys('TotalRevenue'),
      totalRevenueFields
    ),
    createBoTItem('HPSpend', getFormedEltTranslationForKeys('HPSpend'), hpSpendFields),
    createBoTItem(
      'BalanceOfTrade',
      getFormedEltTranslationForKeys('BalanceOfTrade'),
      balanceOfTradeFields
    ),
  ]
}
